import './AwardCard.css';

function AwardCard({ title, year }) {
  return (
    <div className="award-card">
      <div className="award-card__icon">&#9733;</div>
      <h3 className="award-card__title">{title}</h3>
      <p className="award-card__year">{year}</p>
    </div>
  );
}

export default AwardCard;
